export const apqpConstant = {
  phase_1: [
    {
      s_no: 1,
      start_date: {},
      complete_date: {},
      activity:
        "Receive customer enquiry / documents / sample / drawing. ECN & PCN",
    },
    {
      s_no: 2,
      start_date: {},
      complete_date: {},
      activity: "Enter details in New Development Log Book & ECN Log Book ",
    },
    {
      s_no: 3,
      start_date: {},
      complete_date: {},
      activity:
        "Project matches to company’s manufacturing scope & Prepare Specification of Product & Process.",
    },
    {
      s_no: 4,
      start_date: {},
      complete_date: {},
      activity:
        "Reviews the same & in case of any doubt, calls a Specifications Review Meeting with the customer.",
    },
    {
      s_no: 5,
      start_date: {},
      complete_date: {},
      activity:
        "Use best practices & take benefit of TGR / TGW and Past Defect History Records.",
    },
    {
      s_no: 6,
      start_date: {},
      complete_date: {},
      activity:
        "Along with CFT, Study Customer Enquiry /Document /Sample /Drawing ,Specifications,& Special Characteristics .Customer & other Requirements ,Need And expectations are also considered & make Feasibility report.",
    },
    {
      s_no: 7,
      start_date: {},
      complete_date: {},
      activity:
        "In case any change is required from the customer to make the development feasible, communicates the same to the customer for making the necessary changes.",
    },
    {
      s_no: 8,
      start_date: {},
      complete_date: {},
      activity:
        "Prepare Quotation, submit to customer & resolve commercial issues.",
    },
    {
      s_no: 9,
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week ",
    },
  ],
  phase_2: [
    {
      s_no: 1,
      start_date: {},
      complete_date: {},
      activity:
        "Receive Development Order / Purchase Order from the customer. ",
    },
    {
      s_no: 2,
      start_date: {},
      complete_date: {},
      activity:
        "Prepares APQP Timing Plan containing plan of the development activities & control items should be based on APQP Responsibility Matrix & get approval from Top Management  ",
    },
    {
      s_no: 3,
      start_date: {},
      complete_date: {},
      activity: "Prepare Micro Level Tool Development Plan.",
    },
    {
      s_no: 4,
      start_date: {},
      complete_date: {},
      activity: "Prepare Gauge & Fixture Development Plan.",
    },
  ],
  phase_3: [
    {
      s_no: 1,
      start_date: {},
      complete_date: {},
      activity: "Prepare Process Flow Chart.",
    },
    {
      s_no: 2,
      start_date: {},
      complete_date: {},
      activity: "CFT will Prepare PFMEA Matrix.",
    },
    {
      s_no: 3,
      start_date: {},
      complete_date: {},
      activity: "CFT will Prepare PFMEA.",
    },
    {
      s_no: 4,
      start_date: {},
      complete_date: {},
      activity: "Prepare Pre-launch Control Plan.",
    },

    {
      s_no: 5,
      start_date: {},
      complete_date: {},
      activity:
        "Prepare All process instruction providing instructions providing sufficient understanding and details for all personnel who have direct responsibility for the operation of the processes on the basis of pre- launch control plan & other Supporting Document .",
    },
    {
      s_no: 6,
      start_date: {},
      complete_date: {},
      activity: "Prepare Packaging Standard as per customer requirement",
    },
    {
      s_no: 7,
      start_date: {},
      complete_date: {},
      activity:
        "Training shall be provided to all persons of Concerned departments before Start Sample Trial.",
    },
    {
      s_no: 8,
      start_date: {},
      complete_date: {},
      activity: "T – 1 Trial",
    },
    {
      s_no: "8a",
      start_date: {},
      complete_date: {},
      activity: "T1 Trial Run",
    },
    {
      s_no: "8b",
      start_date: {},
      complete_date: {},
      activity: "Sample Submission to customer ",
    },
    {
      s_no: "8c",
      start_date: {},
      complete_date: {},
      activity: "Sample Approval from customer",
    },
    {
      s_no: "8d",
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week",
    },
    {
      s_no: "9",
      start_date: {},
      complete_date: {},
      activity: "T – 2 Trial (If required)",
    },
    {
      s_no: "9a",
      start_date: {},
      complete_date: {},
      activity: "T2 Trial Run",
    },
    {
      s_no: "9b",
      start_date: {},
      complete_date: {},
      activity: "Sample Submission to Customer",
    },
    {
      s_no: "9c",
      start_date: {},
      complete_date: {},
      activity: "Sample Approval from customer",
    },
    {
      s_no: "9d",
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week",
    },
    {
      s_no: 10,
      start_date: {},
      complete_date: {},
      activity: "T – 3 Trial (If required)",
    },
    {
      s_no: "10a",
      start_date: {},
      complete_date: {},
      activity: "T3Trial Run",
    },
    {
      s_no: "10b",
      start_date: {},
      complete_date: {},
      activity: "Sample Submission to Customer",
    },
    {
      s_no: "10c",
      start_date: {},
      complete_date: {},
      activity: "Sample Approval from customer",
    },
    {
      s_no: "10d",
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week.",
    },
  ],

  phase_4: [
    {
      s_no: 1,
      start_date: {},
      complete_date: {},
      activity:
        "Training shall be provided to all persons of Concerned departments before Start of manufacturing the Pilot lot ",
    },
    {
      s_no: 2,
      start_date: {},
      complete_date: {},
      activity:
        "Starts manufacturing the Pilot Lot under close monitoring of the CFT as defined in the Pre-launch Control Plan.",
    },
    {
      s_no: 3,
      start_date: {},
      complete_date: {},
      activity:
        "Perform Measurement System Analysis & Process Capability Study as required.",
    },
    {
      s_no: 4,
      start_date: {},
      complete_date: {},
      activity: "Conduct Product & Process Audit.",
    },
    {
      s_no: 5,
      start_date: {},
      complete_date: {},
      activity:
        "Check pilot lot as per the Pre-launch Control Plan & prepare all PPAP documents, including PSW.",
    },
    {
      s_no: 6,
      start_date: {},
      complete_date: {},
      activity:
        "Submit PPAP documents to the customer along with   Pilot Lot for approval.",
    },
    {
      s_no: 7,
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week.",
    },
  ],
  phase_5: [
    {
      s_no: 1,
      start_date: {},
      complete_date: {},
      activity:
        "Receive Pilot Lot Approval Documents from customer & hand over to Quality.",
    },
    {
      s_no: 2,
      start_date: {},
      complete_date: {},
      activity:
        "Record all quality issues in List of Quality Issues / Defects Faced In-house & at Customer End during Trials.",
    },
    {
      s_no: 3,
      start_date: {},
      complete_date: {},
      activity:
        "Analyse & initiate preventive measures through PDCA Analysis Sheet / CAPA Report.",
    },
    {
      s_no: 4,
      start_date: {},
      complete_date: {},
      activity:
        "Prepare TGR / TGW sheet which they faced during the development period.",
    },
    {
      s_no: 5,
      start_date: {},
      complete_date: {},
      activity: "Prepare APQP Sign Off  after SOP at Customer end.",
    },
    {
      s_no: 6,
      start_date: {},
      complete_date: {},
      activity: "Follow up with customer if no response within a week.",
    },
    {
      s_no: 7,
      start_date: {},
      complete_date: {},
      activity:
        "Start Production under IPC & monitoring the production activities closely for each production lot.",
    },
  ],
};
